import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-286640c2")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Altri dati ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Per codice ordine si intende il codice comunicato dal cliente. Generalmente riferito al proprio sistema di gestione ordini. ", -1)
const _hoisted_4 = { class: "p-formgroup-inline" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Contatti d'emergenza per l'ordine. ", -1)
const _hoisted_7 = { class: "p-formgroup-inline" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Data ritiro e consegna ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Il ritiro e la consegna dell'ordine sono garantiti all'iterno della fascia oraria indicata. Qualora sia necessario un ritiro ed una consegna specifica abilitare il flag \"urgenza\" indicando poi gli orari desiderati. L'urgenza implica un costo maggiore per l'esecuzione dell'ordine. ", -1)
const _hoisted_13 = { class: "p-formgroup-inline" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = {
  class: "p-d-flex p-flex-column p-flex-sm-row p-jc-between flex1",
  style: {"max-width":"325px"}
}
const _hoisted_17 = { class: "p-d-flex p-flex-column" }
const _hoisted_18 = { class: "p-field-checkbox" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "pickup_urgency" }, " Ritiro urgente ", -1)
const _hoisted_20 = {
  key: 0,
  class: "p-px-3 p-text-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h6", null, "Orario di ritiro:", -1)
const _hoisted_22 = { class: "p-d-flex p-flex-column" }
const _hoisted_23 = { class: "p-field-checkbox" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "dropoff_urgency" }, " Cosegna urgente ", -1)
const _hoisted_25 = {
  key: 0,
  class: "p-px-3 p-text-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h6", null, "Orario di consegna", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-car" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Tipologia e quantità ")
const _hoisted_29 = { class: "p-formgroup-inline" }
const _hoisted_30 = { class: "p-field" }
const _hoisted_31 = { class: "p-field" }
const _hoisted_32 = { class: "p-d-flex p-jc-between p-mt-6" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_TimeslotSelect = _resolveComponent("TimeslotSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TimeStepper = _resolveComponent("TimeStepper")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "content_nopadding" }, {
      content: _withCtx(() => [
        _createVNode(_component_Fieldset, { class: "p-mb-3" }, {
          legend: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FloatLabel, { label: "Codice ordine" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.extexternalClientCode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.extexternalClientCode = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_FloatLabel, { label: "Nome Mittente" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.refSenderName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.refSenderName = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_FloatLabel, { label: "Numero Mittente" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.refSenderPhone,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.refSenderPhone = $event)),
                      maxlength: "15"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, null, {
          legend: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_FloatLabel, { label: "Data" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Calendar, {
                      minDate: _ctx.minDateValue,
                      modelValue: _ctx.pickupDatetime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pickupDatetime = $event)),
                      dateFormat: "dd-mm-yy",
                      showIcon: true
                    }, null, 8, ["minDate", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_TimeslotSelect, {
                  noPastSlots: _ctx.noPastSlots,
                  modelValue: _ctx.timeslot,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.timeslot = $event)),
                  onChange: _ctx.onTimeslotChange
                }, null, 8, ["noPastSlots", "modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_Checkbox, {
                      binary: "",
                      id: "pickup_urgency",
                      modelValue: _ctx.pickup_priority,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.pickup_priority = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  (_ctx.pickup_priority)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_TimeStepper, {
                          time: _ctx.pickupDatetime,
                          "onUpdate:time": _cache[6] || (_cache[6] = ($event: any) => (_ctx.pickupDatetime = $event)),
                          min: _ctx.minTime,
                          max: _ctx.maxTime
                        }, null, 8, ["time", "min", "max"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_Checkbox, {
                      binary: "",
                      id: "dropoff_urgency",
                      modelValue: _ctx.dropoff_priority,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dropoff_priority = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  (_ctx.dropoff_priority)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_TimeStepper, {
                          time: _ctx.dropoffDatetime,
                          "onUpdate:time": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dropoffDatetime = $event)),
                          min: _ctx.minTime
                        }, null, 8, ["time", "min"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_27,
            _hoisted_28
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.vehicle,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.vehicle = $event)),
                  onChange: _ctx.onVehicleChange,
                  options: _ctx.vehicleOptions,
                  optionLabel: "name_it",
                  placeholder: "Tipologia",
                  style: {"width":"250px"}
                }, null, 8, ["modelValue", "onChange", "options"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_FloatLabel, { label: "Numero colli" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.quantity,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.quantity = $event)),
                      disabled: !_ctx.vehicle?.is_package
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_router_link, { to: _ctx.prevRoute }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Indietro",
            icon: "pi pi-chevron-left",
            class: "p-button-secondary"
          })
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_Button, {
        label: "Avanti",
        icon: "pi pi-chevron-right",
        disabled: !_ctx.timeslot || !_ctx.vehicle,
        onClick: _ctx.goNext
      }, null, 8, ["disabled", "onClick"])
    ])
  ]))
}